import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { PermissionsContext } from '../app/PermissionsContext'
import SubnavAndRoutes from '../app/SubnavAndRoutes'
import ContactNameSearch from './contactname/ContactNameSearch'
import MembershipSearch from './membership/MembershipSearch'
import { CtrSearch } from './ctr/CtrSearch'
import OdmSearch from './odm/OdmSearch'
import UserProfileSearch from './userProfile/UserProfileSearch'
import OdvSearch from './odv/OdvSearch'
import { usePageTitle } from '../app/PageTitleContext'

export default function SearchBase() {
  usePageView({ page_detail: 'DMConsole:SearchBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.search.base'))
  const { isAuthorized } = useContext(PermissionsContext)

  const subNavs = [
    {
      text: t('membership', 'Membership'),
      path: 'membership',
      requiredPermissions: 'ViewAllCmisxData',
      component: MembershipSearch,
    },
    {
      text: t('contactName', 'Contact Name'),
      path: 'contactname',
      requiredPermissions: 'ViewAllCmisxData',
      component: ContactNameSearch,
    },
    {
      text: t('odmId', 'ODM ID'),
      path: 'odm',
      requiredPermissions: ['tss_ReadCtrControlledPermission', 'tss_ReadCtrFullAcdPermission'],
      component: OdmSearch,
    },
    {
      text: t('ctr.label', 'CTR'),
      path: 'ctr',
      requiredPermissions: ['ViewAllCmisxData'],
      component: CtrSearch,
    },
    {
      text: t('user.userProfile.userProfile', 'User Profile'),
      path: 'userProfile',
      requiredPermissions: ['ViewAllCmisxData'],
      component: UserProfileSearch,
    },
    {
      text: t('odv.odmOdmi', 'ODM/ODMI'),
      path: 'odv',
      requiredRoles: [
        'Data Admin 1',
        'Data Admin 2',
        'Data Admin 3',
        'Data Admin 4',
        'Data Admin 5',
        'Data Admin 6',
        'Engineer Admin',
        'Russian Data Admin',
      ],
      component: OdvSearch,
    },
  ]

  const defaultPath = isAuthorized('ViewAllCmisxData') ? 'membership' : ''

  return <SubnavAndRoutes data={subNavs} defaultPath={defaultPath} />
}
